import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import InputLabel from './InputLabel'

interface IProps {
  name: string
  defaultValue?: string
  label?: null | string
  error?: null | string
  required?: boolean
  inputRef?: any
  onChangeHandler?(event: any): void | Promise<void>
}

const InputFile: React.FC<IProps> = props => {
  return (
    <Wrapper className="InputFile">
      {props.label && <InputLabel label={props.label} required={props.required} />}
      <div className="Main">
        {props.defaultValue && <Image key={props.defaultValue} src={props.defaultValue} alt="" />}
        <input
          id={props.name}
          type="file"
          name={props.name}
          required={props.required ? true : false}
          onChange={event => {
            if (typeof props.onChangeHandler === 'function') {
              props.onChangeHandler(event)
            }
          }}
          ref={props.inputRef || null}
        />
        {props.error && <span className="InputFile_Error">{props.error}</span>}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }

  input {
    display: block;
    width: 100%;
    height: 40px;
    padding: 8px 12px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
    font-size: 14px;
    transition: border 0.2s ease;
    outline: none;
    background: none;

    &:not([readonly]):focus {
      border: solid 1px ${constants.COLORS.primary};
    }
  }

  input[readonly] {
    background-color: ${constants.COLORS.divider};
  }

  .Main {
    flex: 1;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
    }
  }

  .InputFile_PostUrl {
    font-size: 13px;
    font-weight: bold;
  }

  .InputFile_Error {
    display: block;
    margin-top: 8px;
    color: ${constants.COLORS.cautionText};
    font-size: 14px;
  }
`

const Image = styled.img`
  display: block;
  max-width: 360px;
  margin-bottom: 12px;

  & + & {
    margin-top: 12px;
  }
`
export default InputFile
